import { useEffect, useState } from "react"
import General from "services/GeneralEndpoints"
import BaselConvention from "../Common/BaselConvention"
import RotterdamConvention from "../Common/RotterdamConvention"

const user = JSON.parse(localStorage.getItem("authUser"))
let generalService = new General(user)

const ViewExport = props => {
  const [convention, setconvention] = useState()
  useEffect(() => {
    fetchApplicationDetails(props.location.search.split("=")[1])
  }, [])

  const fetchApplicationDetails = appId => {
    generalService.getApplicationDetails(appId).then(response => {
      if (response.data.basel_convention !== null) {
        setconvention(<BaselConvention appDetails={response.data} />)
      }
      else if (response.data.rotterdam_convention !== null)
      {
        setconvention(<RotterdamConvention appDetails={response.data} />)

      } else {}
    })
  }

  return <>{convention}</>
}

export default ViewExport
